
<template>
  <div>
    <v-autocomplete 
      v-model="order.modality_id"
      label="Selecione o galpão" 
      :items="depots"
      :rules="required" 
      prepend-icon="mdi-star" 
      item-text="name" 
      item-value="id" 
      :loading="loading"
    ></v-autocomplete>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import Api from '@/api/index';

export default {
  name: 'SimpleSelectDepot',
  mixins: [ validations ],

  props: {
    order: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      depots: [],
      selected_depot: {},
      loading: false,
    }
  }, 
  methods: {
    getModalities() {
      this.loading = true
      Api.Modality.index({index_by_current_user: true, solution: 'retail'}).then(r=> {
        this.depots = r.data
      }).catch(err=>{
        console.log(err)
      }).finally(()=>{
        this.loading = false
      })
    },
  },
  computed: {
    ...mapState({
      current_user_id: state=> state.User.oneUser.data.attributes.id
    })
  },
  mounted () {
    this.getModalities();
  },
}
</script>